/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var tmplDepKeyThirdPartyVendorFormView = require('../templates/DepKeyThirdPartyVendorFormView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepKeyThirdPartyVendorFormView,

  className: 'dep-key-third-party-vendor-form-view',

  ui: {
    trackingForm: 'form',
    enteredDate: '.entered-date',
    asOfDate: '.as-of-date',
    examStartDate: '.exam-start-date'
  },

  onBeforeShow: function() {
    var entityTracking = this.model.get('entityTracking') || {};

    Syphon.deserialize(this, entityTracking);

    this.ui.enteredDate.datepicker();
    this.ui.asOfDate.datepicker();
    this.ui.examStartDate.datepicker();
  },

  validate: function() {
    return this.ui.trackingForm.parsley().whenValidate();
  },

  getFormData: function() {
    return Syphon.serialize(this);
  }
});
